<template>
  <div class="gantt">
    <div class="gantt-fixed-header">
      <div class="search-tool">
        <SearchInput
          v-model="search_input_button.value"
          :placeholder="search_input_button.placeholder"
        />
      </div>
      <div class="fixed-header-item-list">
        <div class="fixed-header-item">
          <p class="header-item-title">
            M01 操作許可證
          </p>
          <div class="header-item-list">
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
          </div>
        </div>
        <div class="fixed-header-item">
          <p class="header-item-title">
            M01 操作許可證
          </p>
          <div class="header-item-list">
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
          </div>
        </div>
        <div class="fixed-header-item">
          <p class="header-item-title">
            M01 操作許可證
          </p>
          <div class="header-item-list">
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
          </div>
        </div>
        <div class="fixed-header-item">
          <p class="header-item-title">
            M01 操作許可證
          </p>
          <div class="header-item-list">
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
            <div class="list-item">
              <i class="icon-datestart" />
              <p class="item-title">
                有效起日
              </p>
              <p class="date">
                2013.01.10
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gantt-bg">
      <div
        v-for="(year_e,year_k) in years"
        :key="year_k"
        class="gantt-bg-row-item"
      >
        <p class="item-title">
          2014
        </p>
        <div class="item-grid" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Gantt",
  data: () => ({
    search_input_button: {
      value: "",
      placeholder: "搜尋",
      textLabel: "搜尋"
    },
    years: [1, 2, 3, 4, 5, 6, 7, 4, 4, 4, 44, 4, 4, 3]
  })
};
</script>
<style lang="scss" scoped>
.gantt {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  background-color: var(--white);
  .gantt-fixed-header {
    position: absolute;
    width: 260px;
    box-shadow: 6px 0 12px -4px rgba(0, 0, 0, 0.16);
    background-color: var(--white);
    @media screen and (max-width: 1023px) {
      width: 200px;
    }
    .search-tool {
      @include flex_align;
      justify-content: center;
      padding: 0 20px;
      height: 86px;
      width: 100%;
    }
    .fixed-header-item {
      padding: 30px 20px 0;
      &:hover {
        box-shadow: 0 0 20px -4px rgba(0, 0, 0, 0.16);
        .header-item-list {
          border: none;
        }
      }
      &:last-child {
        border-top: none;
      }
      .header-item-title {
        font-size: 1rem;
        font-weight: bold;
        line-height: 1.38;
        letter-spacing: 1px;
        color: var(--gray-900);
      }
      .header-item-list {
        @include auto_margin_top(30px);
        padding-bottom: 30px;
        border-bottom: 1px solid var(--blue-50);
        .list-item {
          @include flex_align;
          @include auto_margin_top(30px);
          i {
            font-size: 1.5rem;
            color: var(--gray-900);
          }
          p {
            @include auto_margin_left(7px);
            font-size: 1rem;
            line-height: 1.38;
            letter-spacing: 1px;
            &.item-title {
              color: var(--gray-900);
              @media screen and (max-width: 1023px) {
                display: none;
              }
            }
            &.date {
              @include auto_margin_left(6px);
              color: var(--gray-700);
              @media screen and (max-width: 1023px) {
                @include auto_margin_left(4px);
              }
            }
          }
        }
      }
    }
  }
  .gantt-bg {
    @include flex;
    .gantt-bg-row-item {
      text-align: center;
      min-width: 81px;
      height: 100%;
      .item-title {
        @include flex_align;
        justify-content: center;
        height: 86px;
        font-size: 1rem;
        font-weight: bold;
        line-height: 1.38;
        letter-spacing: 1px;
        border-bottom: 1px solid #d8d8d8;
        color: var(--gray-700);
      }
      .item-grid {
        width: 100%;
        min-height: 732px;
        border: 1px solid #d8d8d8;
        border-bottom: none;
        border-top: none;
      }
    }
  }
}
</style>